<ng-container *ngIf="isDialogVisible && translationKeyTitle">
  <kendo-window class="app-publish-validation-dialog-show-dialog-title" [width]="600" [height]="230" [resizable]="false" [title]="translationKeyTitle">
    <div class="ContentContainer">
      <table aria-hidden="true">
        <tr>
          <td>{{ 'publishValidationDialog.message' | translate }}</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr *ngFor="let field of InvalidFields">
          <td style="padding-left: 20px;">{{ field | translate }}</td>
        </tr>
      </table>
    </div>
    <div class="dialogButtonBar">
      <div class="reportDesignerButtonBarBorder">
        <div class="ButtonBar">
          <button class="ButtonWidth_80px k-button" (click)="cancel()">OK</button>
        </div>
      </div>
    </div>
  </kendo-window>
  <div class="k-overlay"></div>
</ng-container>
